import { useSyncExternalStore } from 'react';

// Track the open editor, independently of which camera is selected in the room.
const panes = new Map<symbol, string>();
const listeners = new Set<() => void>();
const emit = (): void => {
  for (const listener of listeners) listener();
};

/** Prioritize the most recently opened camera pane; restore its parent on close. */
export const registerNotificationDevicePane = (deviceId: string): (() => void) => {
  const key = Symbol();
  panes.set(key, deviceId);
  emit();
  return () => {
    panes.delete(key);
    emit();
  };
};

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
const getSnapshot = (): string | undefined => [...panes.values()].at(-1);

/** Device whose settings pane currently owns notification priority. */
export const useNotificationDevicePane = (): string | undefined =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
